import {analytics} from '../quote-tool/globals/config';

const $ = jQuery;
const $contactForm = $('.js-contact-form-tracking');
const $body = $('body');
let bodyTrackingInfo = $body.data('tracking-info');

export default function () {
    if ($contactForm.length > 0) {
        startTracking();
        submitTracking();
        completeTracking();
        errorTracking();
    }
}

function startTracking() {
    let isStarted = false;
    $contactForm.on('input', 'input, textarea, select', function () {
        if (!isStarted) {
            isStarted = true;
            analytics.trackEvent(trackData.start);
        }
    });
}

function submitTracking() {
    $(document).on('submit', '.js-contact-form-tracking', function () {
        analytics.trackEvent(trackData.submit);
    });
}

function completeTracking() {
    $(document).on('gform_confirmation_loaded', function (event, form_id) {
        analytics.trackEvent(trackData.complete);
    });
}

function errorTracking() {
    $(document).on('gform_post_render', function (event, formId) {
        const $errorInputParents = $('.gfield_error');

        if ($errorInputParents.length > 0) {
            const emptyFieldText = 'field can’t be empty';
            let errorMessages = [];

            $errorInputParents.each(function (index, itemContainer) {
                const classList = itemContainer.classList;
                const trackingClass = Array.from(classList).find((item) => item.includes('js-tracking-input--'));
                let trackingValue = false;

                if (trackingClass) {
                    trackingValue = trackingClass.split('--')[1];
                    if (trackingValue.includes('_')) {
                        trackingValue = trackingValue.replace('_', ' ');
                    }
                }

                if (trackingValue) {
                    errorMessages.push(`${trackingValue} ${emptyFieldText}`);
                }
            });

            if (errorMessages.length > 0) {
                trackData.error.info.errorMessage = errorMessages.join(' | ');
                analytics.trackEvent(trackData.error);
            }
        }
    });
}

let trackData = {
    start: {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'contact-form',
            toolStep: 'personal-info',
            leadID: '',
            requestType: 'contact-dealer',
            toolStepOption: '',
            toolStepNumber: 1,
        },
    },
    submit: {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'contact-form',
            toolStep: 'personal-info',
            leadID: '',
            requestType: 'contact-dealer',
            toolStepOption: bodyTrackingInfo.dealerName,
            toolStepNumber: 1,
        },
    },
    complete: {
        event: 'tool-complete',
        info: {
            toolType: 'request-form',
            toolName: 'contact-form',
            toolStep: 'thank-you',
            leadID: '',
            requestType: 'contact-dealer',
            toolStepOption: '',
            toolStepNumber: 2,
        },
    },
    error: {
        event: 'tool-error',
        info: {
            toolType: 'request-form',
            toolName: 'contact-form',
            toolStep: 'personal-info',
            leadID: '',
            requestType: 'contact-dealer',
            errorType: 'user-error',
            toolStepOption: '',
            toolStepNumber: 1,
            errorMessage: '',
        },
    },
}
